import DogBowl from '@rover/icons/svg/dog-bowl.svg';
import { Flex, Heading, Paragraph } from '@rover/kibble/core';

import { NoResultsWrapper } from './NoResultsWrapper';

// TODO (DEV-104195): Translate text
export default function NoResults(): JSX.Element {
  return (
    <NoResultsWrapper>
      <DogBowl />
      <Flex gap="1x" flexDirection="column" alignItems="center" justifyContent="center">
        <Heading size="200" textColor="tertiary" m="0x">
          No trainers matched your search.
        </Heading>
        <Paragraph size="100" textColor="tertiary" m="0x" textAlign="center">
          Verify your location to ensure you see all trainers near you.
        </Paragraph>
      </Flex>
    </NoResultsWrapper>
  );
}
